import sound from './laugh.wav';export default sound;